module.exports = __webpack_public_path__ + "img/crossing-the-rock.1697de20.png";